// React
import { createContext, useContext } from "react";

const QRContext = createContext();

/**
 * @brief Custom hook to access the QRContext. It ensures that the hook is used within a QRContext Provider.
 * @returns {Object} The context value containing the current state and functions to update the state related to QR code scanning.
 * @throws Will throw an error if the hook is used outside of a QRContext Provider.
 */
export const useQR = () => {
  const context = useContext(QRContext);
  if (!context) {
    throw new Error("useQR must be used within a QRContext Provider");
  }
  return context;
};

export default QRContext;
